import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile-menu-button-container"
}
const _hoisted_2 = { class: "username" }
const _hoisted_3 = { class: "user-greeting" }
const _hoisted_4 = { class: "first-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Profile", -1)
const _hoisted_6 = { class: "profile-menu-header" }
const _hoisted_7 = { class: "username" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "profile-menu" }
const _hoisted_11 = {
  class: "offers",
  href: "/campaigns"
}
const _hoisted_12 = {
  class: "favorites",
  href: "/favorites"
}
const _hoisted_13 = {
  class: "order-history",
  href: "/order-history"
}
const _hoisted_14 = {
  class: "my-account",
  href: "/profile"
}

import MembershipCard from "@/components/MembershipCard.vue";
import {computed, reactive} from "vue";
import {AuthStore} from "@/stores/auth";
import { useI18n } from "vue-i18n";
import router from "@/router";

interface State {
    showProfileMenu: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  setup(__props) {

const {t} = useI18n();
const  authStore = AuthStore();

const state = reactive<State>({
    showProfileMenu: false
});

const showProfileMenu = (e:any) => {
  e.preventDefault();
  state.showProfileMenu = !state.showProfileMenu;
};

const logout = ()=>{
  authStore.logout().then(()=>{
    //reload the current page;
    router.go(0);
  });
};


return (_ctx: any,_cache: any) => {
  return (_unref(authStore).state.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn btn-login",
          onClick: showProfileMenu
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('profile.menu.userGreeting')), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(authStore).state.user?.name), 1)
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["profile-menu-container", [state.showProfileMenu ? 'open' : 'closed']])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(authStore).state.user?.name) + " " + _toDisplayString(_unref(authStore).state.user?.lastName), 1),
            _createElementVNode("button", {
              class: "btn btn-close",
              onClick: showProfileMenu
            }, _hoisted_9)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(t)('profile.menu.offers')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(t)('profile.menu.favorites')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)('profile.menu.orderHistory')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(t)('profile.menu.account')), 1)
            ]),
            _createElementVNode("li", null, [
              (_unref(authStore).state.isAuthenticated)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "logout",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(()=> logout(), ["prevent"]))
                  }, _toDisplayString(_unref(t)('profile.menu.logout')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(MembershipCard)
        ], 2),
        (state.showProfileMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "click-outside",
              onClick: showProfileMenu
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})